import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api-service';
import { InfoStore } from './info.store';
import { ConstantsStore } from '../constants.store';
import { TableInfo } from '../../../models/tableInfo';

@Injectable({
  providedIn: 'root'
})
export class InfoService {

  constructor(
    private apiService: ApiService,
    private store: InfoStore,
    private constants: ConstantsStore
  ) { }

  public get(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apiGet()
        .toPromise()
        .then(
          (res: TableInfo[]) => {
            this.store.loadInfo(res);
            resolve(true);
          },
          (error: any) => reject(error)
        );
    });
  }

  public updateInfo(toUpdate: TableInfo): Observable<boolean> {
    return new Observable(observer => {
      this.apiPut(toUpdate)
        .subscribe(
          () => {
            this.store.updateInfo(toUpdate);
            observer.next(true);
          },
          err => observer.error(err)
        );
    });
  }

  /* Search Operations */
  public isThereInfo = (tableTitle: string): boolean => this.store.tablesInfo
    .some(tblInfo => tblInfo.tableName === tableTitle && tblInfo.info)

  public getTableInfo = (tblName: string): TableInfo => this.store.tablesInfo
    .find(tblInfo => tblInfo.tableName === tblName && tblInfo.info)


  /* API Calls*/
  private apiGet() {
    return this.apiService.get<TableInfo[]>(this.constants.infoUrl);
  }
  private apiPut(infoToUpdate: TableInfo) {
    return this.apiService.put<TableInfo>(this.constants.infoUrl, infoToUpdate);
  }

}
